import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { TableComponent } from './table/table.component';
import { SortModalComponent } from './sort-modal/sort-modal.component';
import { DocumentViewerDialogComponent } from './document-viewer-dialog/document-viewer-dialog.component';
import { ChartCanvasComponent } from './chart/chart.component';
import { DashboardViewComponent } from './dashboard/dashboard-view.component';

// Services
import { AdvancedSortService } from './services/advanced-sort.service';
import { FilterService } from './services/filter.service';
import { TableSearchManagerService } from './services/table-search-manager.service';
import { SearchSortService } from './services/search-sort.service';
import { DateUtilityService } from './services/date-utility.service';
import { DataCommunicationService } from './services/data-communication.service';
 
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';

const MATERIAL = [
    MatSelectModule, MatFormFieldModule, MatInputModule, MatCheckboxModule,
    MatOptionModule, MatDatepickerModule, MatNativeDateModule, MatTooltipModule,
    MatDialogModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule,
    MatCardModule, MatMenuModule
];

@NgModule({
    declarations: [
        TableComponent,
        DocumentViewerDialogComponent,
        ChartCanvasComponent,
        DashboardViewComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        DragDropModule,
        SortModalComponent, // standalone
        ...MATERIAL
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        DragDropModule,
        TableComponent,
        SortModalComponent,
        DocumentViewerDialogComponent,
        ChartCanvasComponent,
        DashboardViewComponent,
        ...MATERIAL
    ],
    providers: [
        AdvancedSortService,
        FilterService,
        TableSearchManagerService,
        SearchSortService,
        DateUtilityService,
        DataCommunicationService,
        FilterService
    ]
})
export class SharedComponentsModule { }
